import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { Fab, useScrollTrigger, Zoom } from '@mui/material'

function ScrollTop() {
	const trigger = useScrollTrigger({ threshold: 100 })

	const handleClick = () => {
		window.scrollTo({ top: 0, behavior: 'smooth' })
	}

	return (
		<Zoom in={trigger}>
			<Fab
				onClick={handleClick}
				size='middle'
				color='primary'
				style={{ position: 'fixed', bottom: 32, right: 32 }}
			>
				<KeyboardArrowUpIcon />
			</Fab>
		</Zoom>
	)
}

export default ScrollTop
